var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { IDP_ISSUER_REQUIREMENTS, isValidIdpIssuer } from "healthex-common/idp-issuer.validator";
import { action, computed, observable } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
export class AdminIdpConfigViewModel {
    constructor(opts) {
        this.organization = NOT_LOADED;
        this.issuers = [];
        this.newIssuerInput = "";
        this.issuerListError = null;
        this.authEndpointInput = "";
        this.authEndpointHeadersInput = "";
        this.clientIdInput = "";
        this.clientSecretInput = "";
        this.scopeInput = "";
        this.tokenEndpointInput = "";
        this.tokenEndpointHeadersInput = "";
        this.saving = false;
        this.organizationsManager = opts.container.organizationsManager;
        this.onSave = opts.onSave;
        void this.loadOrganization();
    }
    get newIssuerValidationError() {
        const trimmed = this.newIssuerInput.trim();
        if (!trimmed)
            return null;
        return isValidIdpIssuer(trimmed) ? null : `Issuer must be a ${IDP_ISSUER_REQUIREMENTS}`;
    }
    get authEndpointError() {
        const trimmed = this.authEndpointInput.trim();
        if (!trimmed)
            return null;
        return isValidIdpIssuer(trimmed) ? null : `Auth endpoint must be a ${IDP_ISSUER_REQUIREMENTS}`;
    }
    get tokenEndpointError() {
        const trimmed = this.tokenEndpointInput.trim();
        if (!trimmed)
            return null;
        return isValidIdpIssuer(trimmed) ? null : `Token endpoint must be a ${IDP_ISSUER_REQUIREMENTS}`;
    }
    parseHeadersInput(input) {
        const trimmed = input.trim();
        if (!trimmed)
            return null;
        let parsed;
        try {
            parsed = JSON.parse(trimmed);
        }
        catch {
            return undefined;
        }
        if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed))
            return undefined;
        const entries = Object.entries(parsed);
        if (!entries.every(([, value]) => typeof value === "string"))
            return undefined;
        return parsed;
    }
    get authEndpointHeadersError() {
        if (!this.authEndpointHeadersInput.trim())
            return null;
        return this.parseHeadersInput(this.authEndpointHeadersInput) === undefined
            ? "Headers must be a JSON object of string name/value pairs"
            : null;
    }
    get tokenEndpointHeadersError() {
        if (!this.tokenEndpointHeadersInput.trim())
            return null;
        return this.parseHeadersInput(this.tokenEndpointHeadersInput) === undefined
            ? "Headers must be a JSON object of string name/value pairs"
            : null;
    }
    get canAddIssuer() {
        return this.newIssuerInput.trim().length > 0 && this.newIssuerValidationError === null;
    }
    get canSave() {
        if (this.organization === NOT_LOADED || !this.organization)
            return false;
        return (this.authEndpointError === null &&
            this.tokenEndpointError === null &&
            this.authEndpointHeadersError === null &&
            this.tokenEndpointHeadersError === null);
    }
    updateNewIssuerInput(value) {
        this.newIssuerInput = value;
        this.issuerListError = null;
    }
    addIssuer() {
        const trimmed = this.newIssuerInput.trim();
        if (!trimmed || this.newIssuerValidationError !== null)
            return;
        if (this.issuers.includes(trimmed)) {
            this.issuerListError = "Issuer already added";
            return;
        }
        this.issuers = [...this.issuers, trimmed];
        this.newIssuerInput = "";
        this.issuerListError = null;
    }
    removeIssuer(iss) {
        this.issuers = this.issuers.filter((i) => i !== iss);
    }
    updateAuthEndpointInput(value) {
        this.authEndpointInput = value;
    }
    updateAuthEndpointHeadersInput(value) {
        this.authEndpointHeadersInput = value;
    }
    updateClientIdInput(value) {
        this.clientIdInput = value;
    }
    updateClientSecretInput(value) {
        this.clientSecretInput = value;
    }
    updateScopeInput(value) {
        this.scopeInput = value;
    }
    updateTokenEndpointInput(value) {
        this.tokenEndpointInput = value;
    }
    updateTokenEndpointHeadersInput(value) {
        this.tokenEndpointHeadersInput = value;
    }
    async save() {
        if (this.organization === NOT_LOADED || !this.organization)
            return;
        if (!this.canSave)
            return;
        const auth = this.authEndpointInput.trim();
        const cid = this.clientIdInput.trim();
        const sec = this.clientSecretInput.trim();
        const scope = this.scopeInput.trim();
        const token = this.tokenEndpointInput.trim();
        const authHeaders = this.parseHeadersInput(this.authEndpointHeadersInput);
        const tokenHeaders = this.parseHeadersInput(this.tokenEndpointHeadersInput);
        if (authHeaders === undefined || tokenHeaders === undefined)
            return;
        this.saving = true;
        try {
            await this.organizationsManager.updateOrganizationDetails(this.organization.id, {
                type: this.organization.type,
                allowedIdpIssuers: this.issuers,
                idpAuthEndpoint: auth.length === 0 ? null : auth,
                idpAuthEndpointHeaders: authHeaders,
                idpClientId: cid.length === 0 ? null : cid,
                idpClientSecret: sec.length === 0 ? null : sec,
                idpScope: scope.length === 0 ? null : scope,
                idpTokenEndpoint: token.length === 0 ? null : token,
                idpTokenEndpointHeaders: tokenHeaders,
            });
            await this.loadOrganization();
            this.onSave();
        }
        finally {
            this.saving = false;
        }
    }
    async loadOrganization() {
        var _a, _b, _c, _d, _e, _f;
        const organization = this.organizationsManager.myOrganization.value;
        if (organization && organization !== NOT_LOADED) {
            this.organization = organization;
            this.issuers = [...((_a = organization.allowedIdpIssuers) !== null && _a !== void 0 ? _a : [])];
            this.authEndpointInput = (_b = organization.idpAuthEndpoint) !== null && _b !== void 0 ? _b : "";
            this.authEndpointHeadersInput = organization.idpAuthEndpointHeaders
                ? JSON.stringify(organization.idpAuthEndpointHeaders, null, 2)
                : "";
            this.clientIdInput = (_c = organization.idpClientId) !== null && _c !== void 0 ? _c : "";
            this.clientSecretInput = (_d = organization.idpClientSecret) !== null && _d !== void 0 ? _d : "";
            this.scopeInput = (_e = organization.idpScope) !== null && _e !== void 0 ? _e : "";
            this.tokenEndpointInput = (_f = organization.idpTokenEndpoint) !== null && _f !== void 0 ? _f : "";
            this.tokenEndpointHeadersInput = organization.idpTokenEndpointHeaders
                ? JSON.stringify(organization.idpTokenEndpointHeaders, null, 2)
                : "";
        }
    }
}
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "organization", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "issuers", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "newIssuerInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "issuerListError", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "authEndpointInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "authEndpointHeadersInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "clientIdInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "clientSecretInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "scopeInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "tokenEndpointInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "tokenEndpointHeadersInput", void 0);
__decorate([
    observable
], AdminIdpConfigViewModel.prototype, "saving", void 0);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "newIssuerValidationError", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "authEndpointError", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "tokenEndpointError", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "authEndpointHeadersError", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "tokenEndpointHeadersError", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "canAddIssuer", null);
__decorate([
    computed
], AdminIdpConfigViewModel.prototype, "canSave", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateNewIssuerInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "addIssuer", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "removeIssuer", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateAuthEndpointInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateAuthEndpointHeadersInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateClientIdInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateClientSecretInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateScopeInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateTokenEndpointInput", null);
__decorate([
    action
], AdminIdpConfigViewModel.prototype, "updateTokenEndpointHeadersInput", null);
